module.exports = __webpack_public_path__ + "static/media/smartphone.8b581dd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/smartphone.svg
// module id = 1330
// module chunks = 0